import Info from '@mui/icons-material/Info';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { FC } from 'react';

import { useDialogState } from 'library/hooks/useDialogState';
import { Disable, Sxable } from 'library/types';

import { BaseDialogProps, DialogCloseProps } from '../dialogs/BaseDialog';

export type DialogDataProps<T = unknown> = {
	data: T;
};

interface DialogIconButtonProps<
	T = Partial<BaseDialogProps> | DialogDataProps<unknown>,
> extends Sxable,
		Disable {
	dialogProps: T;
	DialogComponent: FC<T & DialogCloseProps>;
	Icon?: React.ReactNode;
	tooltipText?: string;
	onOpen?: () => void;
}

export const DialogIconButton = <T,>({
	disabled,
	dialogProps,
	DialogComponent,
	tooltipText,
	Icon = <Info />,
	onOpen,
}: DialogIconButtonProps<T>) => {
	const { open, handleOpen, handleClose } = useDialogState(false);

	const handleClick = () => {
		onOpen?.();
		handleOpen();
	};

	return (
		<>
			<Tooltip
				disableHoverListener={!tooltipText}
				title={tooltipText}
				arrow>
				<span>
					<IconButton disabled={disabled} onClick={handleClick}>
						{Icon}
					</IconButton>
				</span>
			</Tooltip>
			{open && <DialogComponent onClose={handleClose} {...dialogProps} />}
		</>
	);
};
